
@import "../../global/variables";
@import '../../global/accessibility.css';
@import '../../global/mixins';

.notifier {
    &--open {
        z-index: 10;
        position: relative;
        &:after {
            content: "";
            width: 100%;
            height: 100%;
            background: rgba(243,243,243,.5);
            position: fixed;
            top: 0;
            left: 0;
            pointer-events: none;
        }
    }

    &__toggler {
        color: $colour-nightjet-accent;
        padding: 10px 16px;
        border: 1px solid $colour-nightjet-accent;
        background: transparent;
        cursor: pointer;
        display: flex;
        gap: 10px;
        align-items: center;
        position: relative;
        z-index: 1;

        &:hover,
        &:focus-visible {
            background: $colour-nightjet-accent;
            color: $color-white;
        }

        svg {
            fill: currentColor;
        }
    }

    &__dialog {
        display: none;

        .notifier--open & {
            display: block;
            position: absolute;
            bottom: -18px;
            right: 0;
            background: $color-white;
            z-index: 1;
            transform: translateY(100%);
            padding: 16px 16px 24px;
            box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.25);
            width: 520px;
            max-width: calc(100vw - 32px);
            text-align: left;

            &:after {
                content: "";
                display: block;
                width: 0;
                height: 0;
                position: absolute;
                top: 0;
                right: 0;
                border-style: solid;
                border-width: 0 13px 12px 13px;
                border-color: transparent transparent $color-white transparent;
                transform: translate(-25%, -100%);
            }
        }
    }

    &__title {
        margin-block-start: 0;
        margin-block-end: 1rem;
    }

    &__form {
        display: grid;
        gap: 1rem;
    }

    &__checkbox {
        display: flex;
        align-items: flex-start;
        gap: 10px;

        .privacy-link {
            @include nj-back-link;
            font-weight: bold;
        }

        &--invalid {
            outline: 1px solid $color-oebb-red;
        }
    }

    &__error-message {
        color: $color-oebb-red;
    }

    .button--primary {
        @include nj-button;
        text-decoration: none;
        display: block;
        width: 100%;

        fill: currentColor;
    }

    &__cancel {
        position: absolute;
        right: 1rem;
        top: 1rem;
        background: transparent;
        border: none;
        width: 40px;
        height: 40px;
        cursor: pointer;

        svg {
            fill: currentColor;
        }

        &:hover,
        &:focus-visible {
            color: $colour-nightjet-accent;
        }
    }
}

